import { getAllSaidas, saveSaida, updateSaida, filterAll, deleteSaida, getBalanco } from '@/services/api/saida.js';
export const actions = {
  async getBalancoBySaida(state, filter) {
    try {
      const dataList = await getBalanco(filter);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getSaidasByFilter(state, filter) {
    try {
      const dataList = await filterAll(filter);
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async getAllSaidas(state) {
    try {
      const dataList = await getAllSaidas();
      state.commit('SET_LIST', dataList);
      return dataList;
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Erro ao processar a requisição!',
          message: 'Se o problema persistir, favor contatar o suporte.',
          buttonText: 'VOLTAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async saveSaida(state, payload) {
    try {
      await saveSaida(payload);
    } catch (error) {
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro realizado',
          message: `Cadastrado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async updateSaida(state, payload) {
    try {
      await updateSaida(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
  async deleteSaida(state, payload) {
    try {
      await deleteSaida(payload);
    } catch (error) {
      /* eslint-disable */
      console.log(error)
      state.dispatch(
        'modal/showModal',
        {
          title: 'Cadastro Atualizado',
          message: `Editado com sucesso.`,
          buttonText: 'FECHAR',
        },
        {
          root: true,
        }
      );
    }
  },
}
